export const getSearchResults = (searchString) => {
    return [
      {
        method: "GET",
        url: `/donor-portal/api/account/findAccountDetailsForCSRUser?accountNumber=${searchString}`,
        page: "adminSearch"
      }
    ]
}

